/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_NInputs */

const en_tut_audio_n = /** @type {(inputs: Tut_Audio_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nearby audio switches itself off in private rooms, locked rooms, meeting rooms, during a focus phase, and while your status is unavailable. It is never recorded or transcribed. Nearby chat lasts two minutes at most, disappears when you change area, is invisible to people who arrive later, and is not covered by message search — for anything you need to find again, use a channel or a DM.`)
};

const id_tut_audio_n = /** @type {(inputs: Tut_Audio_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio sekitar mati sendiri di ruang privat, ruang terkunci, ruang rapat, saat fase fokus, dan saat status Anda tidak tersedia. Ia tidak direkam dan tidak ditranskripsi. Chat sekitar bertahan paling lama dua menit, hilang saat Anda pindah area, tidak terbaca oleh yang baru datang, dan tidak muncul di pencarian pesan — untuk hal yang perlu ditemukan lagi, pakai channel atau DM.`)
};

/**
* | output |
* | --- |
* | "Nearby audio switches itself off in private rooms, locked rooms, meeting rooms, during a focus phase, and while your status is unavailable. It is never recor..." |
*
* @param {Tut_Audio_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_n = /** @type {((inputs?: Tut_Audio_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_n(inputs)
	return en_tut_audio_n(inputs)
});